import axios from "./axios";

const Allowredeem = () =>
  axios.get(`/meeting/allow_redeem/`).then(
    (res) => res,
    (err) => err.response
  );

export { Allowredeem };